var _g, _g2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_241_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94873 10.6428C9.94873 8.43369 11.7396 6.64282 13.9487 6.64282H25.1196C26.7004 6.64282 28.1329 7.57376 28.7749 9.01827L30.3745 12.6175C30.7922 13.5573 31.5558 14.3001 32.5068 14.6916L35.5738 15.9545C37.0726 16.5717 38.0508 18.0323 38.0508 19.6532V37.3571C38.0508 39.5662 36.2599 41.3571 34.0508 41.3571H13.9487C11.7396 41.3571 9.94873 39.5662 9.94873 37.3571V10.6428Z",
    fill: "#D49EFF",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0508 40.8571H13.9487C12.0157 40.8571 10.4487 39.2901 10.4487 37.3571V10.6428C10.4487 8.70983 12.0157 7.14282 13.9487 7.14282H25.1196C26.5028 7.14282 27.7562 7.95739 28.318 9.22134L29.9176 12.8205C30.3875 13.8778 31.2466 14.7135 32.3164 15.154L35.3834 16.4169C36.6949 16.9569 37.5508 18.2349 37.5508 19.6532V37.3571C37.5508 39.2901 35.9838 40.8571 34.0508 40.8571Z",
    stroke: "url(#paint0_linear_241_1372)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_241_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94873 10.6428C9.94873 8.43369 11.7396 6.64282 13.9487 6.64282H25.3023C26.9983 6.64282 28.5099 7.71229 29.0743 9.31154L30.0009 11.937C30.3889 13.0361 31.2369 13.9113 32.3231 14.3338L35.5006 15.5694C37.038 16.1674 38.0508 17.6478 38.0508 19.2975V37.3571C38.0508 39.5662 36.2599 41.3571 34.0508 41.3571H13.9487C11.7396 41.3571 9.94873 39.5662 9.94873 37.3571V10.6428Z",
    fill: "#D49EFF",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0508 40.8571H13.9487C12.0157 40.8571 10.4487 39.2901 10.4487 37.3571V10.6428C10.4487 8.70983 12.0157 7.14282 13.9487 7.14282H25.3023C26.7863 7.14282 28.1089 8.07861 28.6028 9.47795L29.5295 12.1034C29.9659 13.3399 30.9198 14.3245 32.1419 14.7998L35.3193 16.0354C36.6646 16.5586 37.5508 17.854 37.5508 19.2975V37.3571C37.5508 39.2901 35.9838 40.8571 34.0508 40.8571Z",
    stroke: "url(#paint1_linear_241_1372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4795 8.99164C26.4795 7.20983 28.6338 6.31749 29.8937 7.57742L33.4223 11.1061L36.951 14.6347C38.2109 15.8946 37.3186 18.0489 35.5368 18.0489H28.4795C27.3749 18.0489 26.4795 17.1535 26.4795 16.0489V8.99164Z",
    fill: "#A93EC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8832 23.504C17.4267 23.504 17.0566 23.8741 17.0566 24.3306C17.0566 24.787 17.4267 25.1571 17.8832 25.1571H30.1158C30.5723 25.1571 30.9424 24.787 30.9424 24.3306C30.9424 23.8741 30.5723 23.504 30.1158 23.504H17.8832ZM17.8832 30.447C17.4267 30.447 17.0567 30.817 17.0567 31.2735C17.0567 31.73 17.4267 32.1 17.8832 32.1H24.3301C24.7866 32.1 25.1567 31.73 25.1567 31.2735C25.1567 30.817 24.7866 30.447 24.3301 30.447H17.8832Z",
    fill: "#A93EC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_241_1372",
    x: -5.05127,
    y: -8.35718,
    width: 58.1021,
    height: 64.7143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_241_1372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_241_1372",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_241_1372"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_241_1372",
    x: -5.05127,
    y: -8.35718,
    width: 58.1021,
    height: 64.7143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_241_1372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_241_1372",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_241_1372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_1372",
    x1: 9.94873,
    y1: 6.64282,
    x2: 34.3095,
    y2: 38.2249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_1372",
    x1: 9.94873,
    y1: 6.64282,
    x2: 34.3095,
    y2: 38.2249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.77fc7f32467eec16c5ebea675d29c75b.svg";
export { ForwardRef as ReactComponent };